import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AreYouSureGuard } from '@app/core/are-you-sure-guard/are-you-sure.guard';
import { StatementsAccountingConnectionsComponent } from './pages/statements-accounting-connections/statements-accounting-connections.component';
import { FullScreenModalComponent } from '@app/shared/layouts/full-screen-modal/full-screen-modal.component';
import { StatementsSetupFlowComponent } from './components/statements-setup-flow/statements-setup-flow.component';
import { CanSeeStatementsGuard } from './guards/can-see-statements.guard';
import { IsOnboardedToOwnerStatementsGuard } from './guards/IsOnboardedToOwnerStatements.guard';
import { PropertyComponent } from './pages/property/property.component';
import { StatementsPropertiesComponent } from './pages/statements-properties/statements-properties.component';
import { StatementsAddEditOwnerComponent } from './pages/statements-add-edit-owner/statements-add-edit-owner.component';
import { StatementsCommissionsAddComponent } from './pages/statements-commissions-add/statements-commissions-add.component';
import { StatementsCommissionsEditComponent } from './pages/statements-commissions-edit/statements-commissions-edit.component';
import { StatementsCommissionsListComponent } from './pages/statements-commissions-list/statements-commissions-list.component';
import { StatementsDashboardComponent } from './pages/statements-dashboard/statements-dashboard.component';
import { StatementsOnboardingComponent } from './pages/statements-onboarding/statements-onboarding.component';
import { StatementsOwnersListComponent } from './pages/statements-owners-list/statements-owners-list.component';
import { StatementsStatementDetailComponent } from './pages/statements-statement-detail/statements-statement-detail.component';
import { TransactionAddComponent } from '../my-business/pages/transaction-add/transaction-add.component';
import { TransactionsListComponent } from '../my-business/pages/transactions-list/transactions-list.component';
import { StatementsAccountingConnectionEditComponent } from './pages/statements-accounting-connection-edit/statements-accounting-connection-edit.component';
import { StatementsAccountingConnectionNewComponent } from './pages/statements-accounting-connection-new/statements-accounting-connection-new.component';
import { TransactionEditComponent } from '../my-business/pages/transaction-edit/transaction-edit.component';
import { AdjustmentsComponent } from '../my-business/pages/adjustments/adjustments.component';

const routes: Routes = [
  {
    path: '',
    component: StatementsDashboardComponent,
    canActivate: [CanSeeStatementsGuard, IsOnboardedToOwnerStatementsGuard],
    data: {
      title: 'Statements',
      redirectPath: '/demo/statements',
    },
  },
  {
    path: 'owners',
    component: StatementsOwnersListComponent,
    canActivate: [IsOnboardedToOwnerStatementsGuard, CanSeeStatementsGuard],
    data: {
      title: 'Owners',
    },
  },
  {
    path: 'owners/add',
    component: StatementsAddEditOwnerComponent,
    canActivate: [IsOnboardedToOwnerStatementsGuard, CanSeeStatementsGuard],
    data: {
      title: 'New Owner',
    },
  },
  {
    path: 'owners/:id',
    component: StatementsAddEditOwnerComponent,
    canActivate: [IsOnboardedToOwnerStatementsGuard, CanSeeStatementsGuard],
    data: {
      title: 'Edit Owner',
    },
  },
  {
    path: 'commissions',
    component: StatementsCommissionsListComponent,
    canActivate: [IsOnboardedToOwnerStatementsGuard, CanSeeStatementsGuard],
    data: {
      title: 'Commissions',
    },
  },
  {
    path: 'commissions/add',
    component: StatementsCommissionsAddComponent,
    canActivate: [IsOnboardedToOwnerStatementsGuard, CanSeeStatementsGuard],
    data: {
      title: 'New Commission',
    },
  },
  {
    path: 'commissions/:id',
    component: StatementsCommissionsEditComponent,
    canActivate: [IsOnboardedToOwnerStatementsGuard, CanSeeStatementsGuard],
    data: {
      title: 'Commission Details',
    },
  },
  {
    path: 'onboarding',
    component: StatementsOnboardingComponent,
    data: {
      title: 'Get started with Statements',
    },
  },
  {
    path: 'setup/new',
    component: FullScreenModalComponent,
    data: {
      width: '920px',
      title: 'Setup New Statements',
      closeLink: '/operations/statements',
    },
    children: [
      {
        path: '',
        component: StatementsSetupFlowComponent,
        canDeactivate: [AreYouSureGuard],
        data: {
          title: 'Setup New Statements',
        },
      },
    ],
  },
  {
    path: 'setup',
    component: StatementsPropertiesComponent,
    canActivate: [IsOnboardedToOwnerStatementsGuard, CanSeeStatementsGuard],
    data: {
      title: 'Statements Setup',
    },
  },

  {
    path: 'properties/:id',
    component: PropertyComponent,
    canActivate: [IsOnboardedToOwnerStatementsGuard, CanSeeStatementsGuard],
    data: {
      title: 'Statements Property',
    },
  },
  {
    path: 'accounting',
    component: StatementsAccountingConnectionsComponent,
    canActivate: [IsOnboardedToOwnerStatementsGuard, CanSeeStatementsGuard],
    data: {
      title: 'Accounting Integration',
      redirectPath: '/demo/statements',
    },
  },
  {
    path: 'accounting/:id',
    component: StatementsAccountingConnectionEditComponent,
    canActivate: [IsOnboardedToOwnerStatementsGuard, CanSeeStatementsGuard],
    data: {
      title: 'Accounting Integration',
    },
  },
  {
    path: 'accounting/:id/new',
    component: FullScreenModalComponent,
    data: {
      width: '920px',
      title: 'Setup New Connection',
      closeLink: '/operations/statements/accounting',
    },
    children: [
      {
        path: '',
        component: StatementsAccountingConnectionNewComponent,
        canDeactivate: [AreYouSureGuard],
        data: {
          title: 'Setup New Statements',
        },
      },
    ],
  },
  {
    path: ':id',
    component: StatementsStatementDetailComponent,
    canActivate: [IsOnboardedToOwnerStatementsGuard, CanSeeStatementsGuard],
    data: {
      title: 'Statement Detail',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StatementsRoutingModule {}
